// @flow

import React from 'react';
import { connect } from 'react-redux';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import Testable from 'app/common/react/ui/Testable';
import { Experiment } from 'app/common/react/components/experiments';
import { type CarouselPinData } from 'app/packages/pinterest-flow-types/pin';
import { type State as ReduxState } from 'app/common/redux/types';

type ReduxStateProps = {|
  carouselData?: CarouselPinData,
|};

type OwnProps = {|
  handleOneTapLogging: () => void,
  pinDeeplinkUrls: Object,
  pinId: string,
  sourceUrl: string,
|};

type Props = {|
  ...ReduxStateProps,
  ...OwnProps,
|};

export const PinLink = ({
  carouselData,
  handleOneTapLogging,
  pinDeeplinkUrls,
  pinId,
  sourceUrl,
}: Props) => {
  let testId = 'one-tap-desktop';
  let finalLink = sourceUrl;
  let auxData;
  // dynamically return the carousel slot's link
  if (carouselData) {
    const { carousel_slots: carouselSlots = [], id, index } = carouselData;
    if (carouselSlots[index] && carouselSlots[index].link) {
      finalLink = carouselSlots[index].link;
    }
    auxData = {
      carousel_slot_id: carouselSlots[index] && carouselSlots[index].id,
      carousel_data_id: id,
      carousel_slot_index: index,
    };
    testId += '-carousel';
  }

  return (
    <Experiment name="ads_desktop_whitespace_gaps">
      {({ anyEnabled: inAdsDesktopWhitespaceGapsExperiment }) => (
        <div data-test-id={inAdsDesktopWhitespaceGapsExperiment ? 'oneTapPromotedPin' : 'otpp'}>
          <Testable id={testId}>
            <NavigateLink
              auxData={auxData && auxData}
              className="oneTapNavigateLink"
              deeplinkUrls={pinDeeplinkUrls}
              external
              onClick={handleOneTapLogging}
              pinId={pinId}
              stopPropagation
              to={finalLink}
            />
          </Testable>
        </div>
      )}
    </Experiment>
  );
};

const mapStateToProps = ({ pins }: ReduxState, { pinId }: OwnProps): ReduxStateProps => ({
  carouselData: pins[pinId] && pins[pinId].carousel_data,
});

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  () => ({}),
)(PinLink);
